import DropDownMenu from "./DropDownMenu";
import DarkModeToggle from "./DarkModeToggle";
import { NavLink, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuthState } from "./GlobalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faChartSimple,
  faChalkboardUser,
  faCircleInfo,
  faEnvelope,
  faFilePen,
  faHouseChimney,
  faImages,
  faStar,
  faUser,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

function Navbar() {
  const AuthState = useAuthState();
  const [scroll, setScroll] = useState(false);
  const [toggle, setToggle] = useState(false);
  const isStudent = Boolean(AuthState.userData?.student_token);

  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = toggle ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [toggle]);

  const handleLinkClick = () => setToggle(false);

  const studentLinks = [
    { to: "/home", label: "Home", icon: faHouseChimney },
    { to: "/courses", label: "Lectures", icon: faChalkboardUser },
    { to: "/exams", label: "Exams", icon: faFilePen },
    { to: "/my-results", label: "My Results", icon: faChartSimple },
  ];

  const guestLinks = [
    { href: "/#", label: "Home", icon: faHouseChimney },
    { href: "/#about", label: "About", icon: faCircleInfo },
    { href: "/#why-us", label: "Why Us", icon: faStar },
    { href: "/#gallery", label: "Gallery", icon: faImages },
    { href: "/#reviews", label: "Reviews", icon: faStar },
    { href: "/contact-us", label: "Contact Us", icon: faEnvelope },
  ];

  const renderLinkContent = (link) => (
    <>
      <FontAwesomeIcon icon={link.icon} className="student-navbar__icon" />
      <span>{link.label}</span>
    </>
  );

  return (
    <>
      <div
        className={`student-mobile-menu__backdrop ${toggle ? "is-open" : ""}`}
        onClick={() => setToggle(false)}
      />

      <div
        className={`student-mobile-menu__drawer ${toggle ? "is-open" : ""}`}
      >
        <div className="student-mobile-menu__header">
          <img
            src="https://api.our-matrix.com/uploads/assets/logo.png"
            alt="logo"
          />
          <button
            type="button"
            className="student-mobile-menu__close"
            onClick={() => setToggle(false)}
            aria-label="Close menu"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <nav className="student-mobile-menu__nav">
          <ul className="student-mobile-menu__list">
            {isStudent ? (
              <>
                {studentLinks.map((link) => (
                  <li key={link.to}>
                    <NavLink
                      to={link.to}
                      className={({ isActive }) =>
                        `student-mobile-menu__link ${isActive ? "is-active" : ""}`
                      }
                      onClick={handleLinkClick}
                    >
                      {renderLinkContent(link)}
                    </NavLink>
                  </li>
                ))}
                <li>
                  <NavLink
                    to="/home/profile"
                    className={({ isActive }) =>
                      `student-mobile-menu__link ${isActive ? "is-active" : ""}`
                    }
                    onClick={handleLinkClick}
                  >
                    <FontAwesomeIcon
                      icon={faUser}
                      className="student-navbar__icon"
                    />
                    <span>Profile</span>
                  </NavLink>
                </li>
              </>
            ) : (
              guestLinks.map((link) => (
                <li key={link.label}>
                  <a
                    className="student-mobile-menu__link"
                    href={link.href}
                    onClick={handleLinkClick}
                  >
                    {renderLinkContent(link)}
                  </a>
                </li>
              ))
            )}
          </ul>
        </nav>

        {!isStudent && (
          <div className="student-mobile-menu__footer">
            <Link
              to="/signin"
              onClick={handleLinkClick}
              className="sign w-full text-center"
            >
              Login
            </Link>
            <Link
              to="/register"
              onClick={handleLinkClick}
              className="register w-full text-center text-white bg-gradient-to-tr from-[#2AA9DF] via-[#04EFF5] to-[#04EFF5]"
            >
              Sign Up
            </Link>
          </div>
        )}
      </div>

      <div className="student-navbar container-landing">
        <nav
          className={`student-navbar__inner ${scroll ? "is-scrolled" : ""}`}
        >
          <Link className="student-navbar__logo" to="/">
            <img
              src="https://api.our-matrix.com/uploads/assets/logo.png"
              alt="logo"
            />
          </Link>

          <ul className="student-navbar__links">
            {isStudent
              ? studentLinks.map((link) => (
                  <li key={link.to}>
                    <NavLink
                      to={link.to}
                      className={({ isActive }) =>
                        `student-navbar__link ${isActive ? "is-active" : ""}`
                      }
                    >
                      {renderLinkContent(link)}
                    </NavLink>
                  </li>
                ))
              : guestLinks.map((link) => (
                  <li key={link.label}>
                    <a className="student-navbar__link" href={link.href}>
                      {renderLinkContent(link)}
                    </a>
                  </li>
                ))}
          </ul>

          <div className="student-navbar__actions">
            <div className="student-navbar__theme">
              <DarkModeToggle showLabel={false} />
            </div>

            <button
              type="button"
              className="student-navbar__toggle"
              onClick={() => setToggle(!toggle)}
              aria-label="Open menu"
            >
              <FontAwesomeIcon icon={faBars} />
            </button>

            {isStudent ? (
              <DropDownMenu />
            ) : (
              <div className="student-navbar__auth">
                <Link to="/signin" className="sign">
                  Login
                </Link>
                <Link
                  to="/register"
                  className="register text-white bg-gradient-to-tr from-[#2AA9DF] via-[#04EFF5] to-[#04EFF5]"
                >
                  Sign Up
                </Link>
              </div>
            )}
          </div>
        </nav>
      </div>
    </>
  );
}

export default Navbar;
